import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
import { getClientId } from '../../index';
export { resetPassword };
var resetPasswordMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation ResetPassword($clientId: String!, $newPassword: String!, $token: String!) {\n    resetPassword(clientId: $clientId, newPassword: $newPassword, token: $token) {\n      status\n      token\n    }\n  }\n"])));
function resetPassword(_x, _x2) {
  return _resetPassword.apply(this, arguments);
}
function _resetPassword() {
  _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(newPassword, token) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('resetPassword', resetPasswordMutation, {
            clientId: getClientId(),
            newPassword: newPassword,
            token: token
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.resetPassword);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _resetPassword.apply(this, arguments);
}